import type React from "react";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import { Alert } from "~/components/Alert";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { DefaultLayout } from "~/components/Layout";
import { SessionContext } from "~/ory";

export const RegistrationComplete: React.FC = () => {
	const navigate = useNavigate();
	const session = useContext(SessionContext);

	useEffect(() => {
		if (!session) return;
		if (session.account.identity.email_verified) {
			// verified 後にリロードしたパターン
			navigate("/");
		}
	}, [session, navigate]);

	if (!session) return <p>Unauthenticated</p>;

	return (
		<>
			<title>Complete Registration | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<ContentContainer>
						<section className="font-normal flex flex-col gap-8 mt-8">
							<dl>
								<dt className="mb-2 text-xs">USER ID</dt>
								<dd className="text-xs">{session.account.subject_id}</dd>
							</dl>
							<dl>
								<dt className="mb-2 text-xs">NAME</dt>
								<dd className="text-xs">
									{session.account.identity.name.first}{" "}
									{session.account.identity.name.last}
								</dd>
							</dl>
							<dl>
								<dt className="mb-2 text-xs">EMAIL</dt>
								<dd className="text-xs">{session.account.identity.email}</dd>
							</dl>
						</section>
						<Alert type="warning" withIcon>
							Verify email address.
							<br />
							Please check your email box.
						</Alert>
					</ContentContainer>
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};
